import colors from 'config/theme/colors';
import { ENV_CONFIG } from 'config/environment';
import { Hero } from 'components/Hero';
import { PressSection } from 'screens/Landing/PressSection';
import { Marketing } from './Marketing';
import { Community } from './Community';
import { Recommendations } from './Recommendations';
import HeaderAndFooterLayout from 'layouts/HeaderAndFooter';
import { getStartedItems, ourImpactItems } from './constants';

export const GetStartedBackup2Screen = () => {
  return (
    <HeaderAndFooterLayout
      headerVisible={false}
      isLoading={false}
      hasIssues={true}
      footerWhiteLabeled={true}
    >
      <div className="get-started-page">
        <Hero
          title="Stop Guessing Where to Donate"
          subtitle="Oath analyzes thousands of races to identify the campaigns where additional funding can actually change the outcome — and gives you a personalized plan for making the biggest impact."
          formContent="get-started-top-button"
          media={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/get-started-hero.png`}
          bgColor={colors.oathBlue}
        />
        <div className="get-started-content">
          <Marketing
            items={getStartedItems}
            title="Oath makes it easy to make a difference."
            subtitle="If you are outraged by the Trump administration, Oath can help you turn your anger into action!"
          />
          <Marketing items={ourImpactItems} title="Our Impact" />
        </div>
        <Recommendations title="Join to learn where you can make a difference right now:" />
        <Community />
        <PressSection />
      </div>
    </HeaderAndFooterLayout>
  );
};
